import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { InjectedStyledComponent } from '../shared/InjectedStyledComponent.js';

import ColumnItem from './styledComponents/ColumnItem.js';
import LeftColumn from './styledComponents/LeftColumn.js';
import RightColumn from './styledComponents/RightColumn.js';
import Wrapper from './styledComponents/Wrapper.js';
import { ISearchResultItemProps, ISearchResultItemState } from './models';

class RawSearchResultItem extends Component<ISearchResultItemProps, ISearchResultItemState> {
	static configurationKey = 'searchResultItem' as const;
	static styleKey: 'searchResultItem' = 'searchResultItem' as const;
	constructor(props: ISearchResultItemProps) {
		super(props);
	}

	getColumnItems(columnItems: string[]) {
		return columnItems.map((item, key) => <ColumnItem key={key}>{item}</ColumnItem>);
	}

	render() {
		const { className, searchResultItemStore, record } = this.props;

		if (!searchResultItemStore) {
			return null;
		}

		return (
			<Wrapper className={className}>
				{record.value.left && <LeftColumn>{this.getColumnItems(record.value.left)}</LeftColumn>}
				{record.value.right && <RightColumn>{this.getColumnItems(record.value.right)}</RightColumn>}
			</Wrapper>
		);
	}
}

export const SearchResultItem = inject('appStore', 'searchResultItemStore')(observer(RawSearchResultItem));
export default InjectedStyledComponent(SearchResultItem, 'searchResultItem');
